import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {AnagraficaComponent} from './anagrafica';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('usersettings.anagrafica', {
        url: '/rubrica',
        views: {
          'userContent': {
            template: '<anagrafica></anagrafica>'
          }
        },
        ncyBreadcrumb: {
          label: 'Rubrica',
          parent: 'usersettings.index'
        },
        data: {
          authorisationLevel: 1,
          pageTitle: 'Rubrica'
        }
      }
    );
};

stateConfig.$inject = ['$stateProvider'];

export const AnagraficaModule: string = ng
  .module('archiSmall.userSettings.anagraficaModule', [
    'ui.bootstrap',
    uiRouter,
    'ncy-angular-breadcrumb'
  ])
  .component('anagrafica', AnagraficaComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/anagrafica/anagrafica.module.ts